import { ComponentPropsOptions, computed, h } from '@vue/composition-api';
import Handle from '../handle/Handle.vue';
import { NodeProps, ValidConnectionFunc } from '../../types';
import { Position } from '../../types';
import { defineComponent } from '@vue/composition-api';
import { Fragment } from 'vue-frag';
import { PropType } from 'vue';
import { IWorkflowState } from '@/models';
import { HexToRGB } from '@/utils/colorUtils';
import NodeLabel from './NodeLabel';

const DefaultNode = defineComponent<Partial<NodeProps<IWorkflowState>>>({
  name: 'DefaultNode',

  components: {
    Fragment
  },

  props: {
    sourcePosition: {
      type: String,
      default: () => Position.Bottom
    },
    targetPosition: {
      type: String,
      default: () => Position.Top
    },
    selected: {
      type: Boolean
    },
    connectable: {
      type: Boolean,
      default: true
    },
    isValidTargetPos: {
      type: Function as PropType<ValidConnectionFunc>
    },
    isValidSourcePos: {
      type: Function as PropType<ValidConnectionFunc>
    },
    data: {
      type: Object as PropType<IWorkflowState>,
      default: () => ({} as IWorkflowState)
    }
  } as ComponentPropsOptions<Partial<NodeProps<IWorkflowState>>>,

  setup(props, _context) {
    const label = props.data?.name || props.label;

    const nodeColorRGB = computed(() =>
      HexToRGB(props.data!.config?.color ?? '#FFFFFF')
    );

    return () =>
      h(Fragment, [
        h(Handle, {
          props: {
            type: 'target',
            position: props.targetPosition,
            connectable: props.connectable,
            isValidConnection: props.isValidTargetPos
          }
        }),

        h(NodeLabel, { props }),
        h(Handle, {
          props: {
            type: 'source',
            position: props.sourcePosition,
            connectable: props.connectable,
            isValidConnection: props.isValidSourcePos
          }
        })
      ]);
  }
});

export default DefaultNode;
